"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountCard = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../styles/theme"));
const bankAccountCardStyles_1 = __importDefault(require("./bankAccountCardStyles"));
const icon_1 = __importStar(require("../icon/icon"));
const banks_1 = __importDefault(require("../../utils/banks"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const BankAccountCard = ({ bankAccount, deleteBankAccount, submitMakePrimary, editBankAccount, editable, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    // Bank Name
    const getBankName = (bankCode) => {
        const found = banks_1.default.find((element) => element.value === bankCode);
        if (found !== undefined) {
            return found.label;
        }
        return 'Not available';
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(touchableElement_1.default, { onPress: editBankAccount, eventName: "bank_account_edit", disabled: !editable },
            react_1.default.createElement(react_native_1.View, { key: bankAccount.bank_id, style: [
                    styles_1.default.flexOne,
                    styles_1.default.flexDirectionRow,
                    styles_1.default.minimumMarginBetweenElementsVertically,
                    bankAccount.is_primary && {
                        paddingBottom: 8,
                        borderRadius: 16,
                        borderWidth: 2,
                        borderColor: theme_1.default.colors.COLOR_PRIMARY,
                    },
                ] },
                bankAccount.is_primary ? (react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.imageContainer },
                    react_1.default.createElement(icon_1.default, { name: icon_1.GREEN_CHECK_CIRCLE, fill: theme_1.default.colors.COLOR_PRIMARY }),
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: bankAccountCardStyles_1.default.primaryExtraText }, t('bankAccountCard.primary')))) : (react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.imageContainer },
                    react_1.default.createElement(touchableElement_1.default, { style: { paddingTop: 25, bottom: 20 }, onPress: () => submitMakePrimary(bankAccount.bank_id), eventName: "bank_account_make_primary", disabled: !editable },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
                            react_1.default.createElement(icon_1.default, { name: icon_1.UNCHECKED_BOX_ICON }),
                            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: bankAccountCardStyles_1.default.extraText }, t('bankAccountCard.make_primary')))))),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexThree, styles_1.default.flexDirectionColumn] },
                    react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.messageContainer },
                        react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.messageContainerSpacing },
                            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: bankAccountCardStyles_1.default.Text }, `${getBankName(bankAccount.bank_name)}`),
                            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: bankAccountCardStyles_1.default.accountNumberText }, `${bankAccount.bank_account_number}`)))),
                !editable || bankAccount.is_primary ? null : (react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.cardDeleteBackground },
                    react_1.default.createElement(touchableElement_1.default, { onPress: () => deleteBankAccount(bankAccount.bank_id), eventName: "bank_account_delete" },
                        react_1.default.createElement(react_native_1.View, { style: bankAccountCardStyles_1.default.deleteCardContainer },
                            react_1.default.createElement(icon_1.default, { name: icon_1.TRASH_ICON, fill: theme_1.default.colors.COLOR_GRAY_DARK })))))))));
};
exports.BankAccountCard = BankAccountCard;
exports.default = exports.BankAccountCard;
